import { Base64Decode } from "./Base64Decode"

export function Base64URLDecode(data: string): Uint8Array {
  // Replace URL-safe characters back to standard base64
  let base64 = data.replace(/-/g, "+").replace(/_/g, "/")

  // Add padding if necessary
  const padding = base64.length % 4
  if (padding === 2) {
    base64 += "=="
  } else if (padding === 3) {
    base64 += "="
  }

  return Base64Decode(base64)
}
